import React, { useEffect } from 'react';
import {
  Button, CircularProgress, Container, Grid,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Images from '../../../../Configs/images';
import ROUTES from '../../../../Configs/routes';
import { signupVerif } from '../../../../Redux/Models/auth';
import Colors from '../../../../Configs/colors';

export default function SignupVerif({
  classes, error, message, isLoading,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { email, token } = useParams();

  useEffect(() => {
    if (!token || !email) {
      navigate(ROUTES.signin());
    } else {
      dispatch(signupVerif({ token }, email));
    }
  }, [token, email]);

  return (
    <div className={classes.root}>
      <Grid container spacing={0} justifyContent="center">
        <Grid item xs={12} sm={10} md={6} lg={4}>
          <Container sx={{ py: 5, minHeight: '100vh', position: 'relative' }} maxWidth="sm">
            <div className="center">
              <h1>
                <img src={Images.Logo} alt="Boxpack" height={65} />
              </h1>
              <h3 className="mt-6 s-16">Thank you for signing up</h3>

              {isLoading
                ? (
                  <div className="center mt-4">
                    <CircularProgress size={32} sx={{ color: Colors.redLight }} />
                  </div>
                )
                : (
                  <>
                    <div className="height-14 mt-1 desc center" hidden={error}>
                      Your email has been verified
                    </div>
                    <div className="height-14 mt-1 desc center" hidden={!error}>
                      Something wrong:
                      {' '}
                      {message}
                    </div>
                  </>
                )}
            </div>

            <div className="action">
              <Container sx={{ pb: 4 }}>
                <div>
                  <Button disabled={isLoading} size="large" onClick={() => navigate(ROUTES.signin())} variant="contained" className="btn-contained" fullWidth>Back to sign in</Button>
                </div>
              </Container>
            </div>

          </Container>
        </Grid>
      </Grid>
    </div>
  );
}
